export const chapterQuizModalStyles = {
  modalContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: {
      xs: 'auto',
      md: 800,
      lg: 900,
    },
    gap: 2,
    pt: 4,
    px: {
      xs: 2,
      sm: 6,
    },
  },
};
